module.exports = __webpack_public_path__ + "img/glow-yellow1-large.93d66807.png";